import names from '@/interface.json'

// エラーの英単語と日本語の文章を登録しておく
const errors = {
    'Degits': 'の桁数が不正です。',
    'Minimum': 'が最小値を下回っています(最小値：',
    'Maximum': 'が最大値を上回っています(最大値：',
    'Require': 'が入力されていません。',
    'Type': 'は半角数字で入力してください。'
}

export default {
    data() {
        return {
            errors: errors,
            names: names,
        }
    },
    methods: {
        getError(error_data) {
            let errortext = this.errors[error_data['errorType']]
            if (error_data['errorType'] == 'Maximum') {
                errortext += error_data['maxValue'] + ')。'
            } else if (error_data['errorType'] == 'Minimum') {
                errortext += error_data['minValue'] + ')。'
            }
            return errortext
        },
        getName(content_name) {
            const caption = this.names[content_name] ? this.names[content_name].tab + '/' + this.names[content_name].caption : content_name
            return '「' + caption + '」'
        }
    }
}